import { DateTimeString } from 'models/common';

import { CompetitiveGroupStatus } from '../applications/applications';

export enum ImportTaskStatus {
  NEW = 'NEW',
  IN_PROCESS = 'IN_PROCESS',
  SUCCEEDED = 'SUCCEEDED',
  FAILED = 'FAILED',
}

export enum ImportTaskType {
  FIS_GIA = 'FIS_GIA',
  MANUAL_COMPETITIVE_GROUP_CHANGE = 'MANUAL_COMPETITIVE_GROUP_CHANGE',
}

export type ImportTaskPayloadResponse = {
  id: number;
  status: ImportTaskStatus;
  payload?: string;
};

export type ImportTaskResponse = {
  id: number;
  authorUserId: number;
  status: ImportTaskStatus;
  type: ImportTaskType;
  documentId?: number;
  createdAt: DateTimeString;
  updatedAt: DateTimeString;
  details: ImportTaskPayloadResponse[];
};

export type ApplicationStatusModifyDto = {
  applicationId: number;
  competitiveGroupId: number;
  reasonRejectId?: number;
  newStatus?: CompetitiveGroupStatus;
  syncStatus?: SynchStatus;
  statusComment?: string;
  targetOrganizationNumber?: number;
};

export type ApplicationStatusModifyFilters = {
  statuses?: SynchStatus[];
  createFromDate?: DateTimeString;
  createToDate?: DateTimeString;
  updateFromDate?: DateTimeString;
  updateToDate?: DateTimeString;
  hasError?: boolean;
};

export enum SynchStatus {
  NEW = 'Новый', // Новый созданный объект
  IN_PROCESS = 'В процессе синхронизации', // Объект находится в процессе синхронизации. Был отправлен асинхронный запрос. Ожидается ответ
  COMPLETE = 'Синхронизация завершена', // Синхронизация завершена
  FAILED = 'Синхронизация завершилась с ошибкой', // Синхронизация завершилась с ошибкой

  // Статус для ApplicationCancel, пока мы не разберёмся с тем, как правильно отзывать заявления
  DELAYED = 'Отложенный', // Суррогатный статус. Нужен, чтобы сущность с таким статусом никак не обрабатывалась для дальнейшего ручного управления

  // Статусы для пользователя
  USER_CREATING = 'Регистрация пользователя в процессе', // Регистрация пользователя в user-manager в процессе
  USER_CREATED = 'Пользователь зарегистрирован', // Пользователь в user-manager зарегистрирован
  DOCS_SAVED = 'Пользователь зарегистрирован, документы сохранены', // Пользователь в user-manager зарегистрирован, документы в files-manager сохранены
  QUESTIONNAIRES_CREATING = 'Создание анкеты пользователя в процессе', // Создание анкеты пользователя в user-manager в процессе

  // Статус для льгот
  BENEFIT_SENDING = 'Отправка льгот',

  // Статус для person profile change
  PARTLY_COMPLETED = 'Отправка льгот частично завершена',

  // Статус для заявлений, которые изначально были отозваны
  REVOKED = 'Изначально были отозвано',
}
